import { render } from "./BaseMessageBubble.vue?vue&type=template&id=bbb8dbc4"
import script from "./BaseMessageBubble.vue?vue&type=script&lang=js"
export * from "./BaseMessageBubble.vue?vue&type=script&lang=js"

import "./BaseMessageBubble.vue?vue&type=style&index=0&id=bbb8dbc4&lang=css"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__